module.exports = __webpack_public_path__ + "static/img/2_1_1_3.50e65f72.jpg";